import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import VendorCodTransferList from "./VendorCodTransferList";
import VendorPendingCodList from "./VendorPendingCodList ";
import VendorPendingChargeList from "./VendorPendingChargeList ";
import VendorCODTransferAmoutList from "./VendorCODTransferAmoutList";



const VendorCodPaymentTab = ({ vendorId }) => {
    const [activeSubTab, setActiveSubTab] = useState("paid-cod");

    const handleSubTabChange = (event, newValue) => {
        setActiveSubTab(newValue);
    };

    return (
        <Box>
            <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
                <Tabs value={activeSubTab} onChange={handleSubTabChange}>
                    <Tab label="Paid COD" value="paid-cod" />
                    <Tab label="Pending COD" value="pending-cod" />
                    <Tab label="Pending Charge" value="pending-charge" />
                    <Tab label="Transfer Amounts" value="transfer-amounts" />
                </Tabs>
            </Box>

            {activeSubTab === "paid-cod" && (
                <VendorCodTransferList vendorId={vendorId} />
            )}
            {activeSubTab === "pending-cod" && (
                <VendorPendingCodList vendorId={vendorId} />
            )}
            {activeSubTab === "pending-charge" && (
                <VendorPendingChargeList vendorId={vendorId} />
            )}
            {activeSubTab === "transfer-amounts" && (
                <VendorCODTransferAmoutList vendorId={vendorId} />
            )}
        </Box>
    );
};

export default VendorCodPaymentTab;